import { TdsTextarea } from '@scania/tegel-react'
import styled from 'styled-components'

export const Actions = styled.form`
  align-items: center;
  border-top: 1px solid var(--tds-divider-background-discrete);
  display: flex;
  gap: 16px;
  padding: 0 8px;
  width: 100%;
  background: white;
`

export const UserInput = styled(TdsTextarea)`
  display: flex;
  flex: 1;

  .textarea-input.sc-tds-textarea {
    resize: none;
  }
`

export const StyledImg = styled.img`
  height: 64px;
  object-fit: cover;
  overflow: hidden;
  padding-top: 10px;
  width: 64px;
`

export const StyledImgContainer = styled.div`
  display: flex;
  padding-left: 4px;
  padding-right: 4px;
  position: relative;

  @media (min-width: ${({ theme }) => theme.size.xxlg}) {
    button {
      display: none;
    }
    &:hover {
      button {
        display: flex;
      }
    }
  }
`

export const DeleteCrossWrapper = styled.div`
  align-content: center;
  display: flex;
  height: 100%;
  justify-content: center;
  position: absolute;
  width: 100%;
`
